const NAME = 'APPCUES';
const CNameMapping = {
  [NAME]: NAME,
  Appcues: NAME,
  'App Cues': NAME,
  appcues: NAME,
};

export { NAME, CNameMapping };
